<template>
  <div class="organization-list">
    <div
      v-for="(organization, index) in displayedOrganizations"
      :key="organization.name"
      class="organization-list-item">
      <OrganizationLogo
        :organization="organization"
        :show-organization-name="showOrganizationName" />
      <span
        v-if="index !== displayedOrganizations.length - 1"
        class="comma">
        ,
      </span>
    </div>
    <span
      v-if="organizations.length > maxOrganizationDisplayed"
      v-tooltip="moreTooltip"
      class="small more">
      {{ $t('messages.andXMore', [organizations.length - maxOrganizationDisplayed]) }}
    </span>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import OrganizationLogo, { IOrganizationLike } from './OrganizationLogo.vue';

  interface IProps {
    organizations: IOrganizationLike[];
    maxOrganizationDisplayed?: number;
    showOrganizationName?: boolean;
  }

  const props = withDefaults(defineProps<IProps>(), { maxOrganizationDisplayed: 5, showOrganizationName: false });

  const displayedOrganizations = computed(() => props.organizations.slice(0, props.maxOrganizationDisplayed));

  const moreTooltip = computed(() => {
    if (props.organizations.length <= props.maxOrganizationDisplayed) {
      return null;
    }

    return props.organizations.slice(props.maxOrganizationDisplayed).reduce((output, organization) => {
      output += `${organization.name}<br>`;
      return output;
    }, '');
  });
</script>

<style scoped lang="scss">
  .organization-list {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .organization-list-item {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    margin-right: 0.6rem;
    margin-bottom: 0.3rem;
  }

  .comma {
    margin-left: 0.2rem;
    margin-right: 0.6rem;
  }

  .more {
    margin-left: 0.5rem;
    cursor: default;
  }
</style>
